export {Dot} from './Dot';
export type {DotProps} from './Dot';
